






import { Vue, Component, Prop } from "vue-property-decorator";
import { Activity } from "@/graphql/query/activity/feed";
import { BuildingLink } from "./helper";

@Component({ components: { BuildingLink } })
export default class ChangeBuildingGroupLog extends Vue {
  @Prop({ type: Object, required: true }) activity!: Activity;
}
